var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.cadastroOriginal.tipoReurbIndividual
        ? _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _vm.isPessoaJuridicaReurb
                ? _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            attrs: {
                              id: "TIPO_REURB",
                              label: "Tipo de Reurb:",
                              content: _vm.formataTipoReurb(
                                _vm.cadastroOriginal.tipoReurbIndividual
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            attrs: {
                              id: "TIPO_REQUERENTE",
                              label: "Tipo requerente:",
                              content: _vm.formatarTexto(
                                _vm.cadastroOriginal.tipoRequerente
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isPessoaFisica &&
              _vm.isPessoaJuridicaReurb &&
              _vm.isTipoRequerentePj
                ? _c(
                    "div",
                    { attrs: { slot: "body" }, slot: "body" },
                    [
                      _c("app-divider", {
                        attrs: { label: "Dados Requerente" }
                      }),
                      _vm.isPessoaJuridicaReurb
                        ? _c(
                            "el-row",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("app-display", {
                                    attrs: {
                                      id: "CNPJ",
                                      label: "CNPJ:",
                                      content:
                                        _vm.cadastroOriginal.cnpjRequerente
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("app-display", {
                                    attrs: {
                                      id: "RAZAO_SOCIAL",
                                      label: "Razão social:",
                                      content:
                                        _vm.cadastroOriginal
                                          .razaoSocialRequerente
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      !_vm.cadastroOriginal.tipoReurbIndividual &&
      _vm.isReurb &&
      _vm.isPessoaJuridicaReurb
        ? _c(
            "div",
            [
              _c(
                "el-col",
                [
                  _c("app-display", {
                    attrs: {
                      content:
                        "Não foi informado nenhum dado durante o cadastro."
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isReurb && !_vm.isPessoaJuridicaReurb
        ? _c("app-divider", { attrs: { label: "Dados Interessado" } })
        : _vm._e(),
      !_vm.isPessoaJuridicaReurb
        ? _c("informacoes-pessoa", {
            attrs: {
              pessoa: _vm.interessado.pessoa,
              razaoSocialName: _vm.isOnerosoGroup
                ? "Razão Social:"
                : "Associação/Comunidade:",
              rendaFamiliar: _vm.interessado.rendaFamiliar,
              membroFamilia: _vm.membroInteressadoPorNome,
              compararInformacoesPessoa:
                _vm.compararInteressado && _vm.compararInteressado.mudouPessoa,
              isProcessoFisico: _vm.isProcessoFisico,
              isReurb: _vm.isReurb,
              isBancoDados: _vm.isBancoDados,
              cnpjRequerente: _vm.cadastroOriginal.cnpjRequerente,
              razaoSocialRequerente: _vm.cadastroOriginal.razaoSocialRequerente
            }
          })
        : _vm._e(),
      _vm.interessado.sociosRepresentantesLegais &&
      _vm.interessado.sociosRepresentantesLegais.length > 0 &&
      !_vm.isPessoaJuridicaReurb
        ? _c(
            "app-collapse",
            {
              attrs: {
                title: _vm.labelSocioRepresentante.titleSocioRepresentante
              }
            },
            _vm._l(_vm.interessado.sociosRepresentantesLegais, function(
              socio,
              index
            ) {
              return _c(
                "app-collapse-child",
                {
                  key: socio.id,
                  attrs: { title: socio.pessoa.pessoaFisica.nome }
                },
                [
                  _c("informacoes-pessoa", {
                    attrs: {
                      pessoa: socio,
                      isSocio: true,
                      isSocioRepresentanteLegal: true,
                      razaoSocialName: _vm.isOnerosoGroup
                        ? "Razão Social:"
                        : "Associação/Comunidade:",
                      compararInformacoesPessoa:
                        _vm.compararInteressado &&
                        _vm.compararInteressado.mudouSocioRepresentanteLegal,
                      compararIsSocioRepresentanteLegal:
                        _vm.compararInteressado &&
                        _vm.compararInteressado.mudouSocioRepresentanteLegal,
                      cnpjRequerente: _vm.cadastroOriginal.cnpjRequerente,
                      razaoSocialRequerente:
                        _vm.cadastroOriginal.razaoSocialRequerente
                    }
                  }),
                  socio.documentos && socio.documentos.length > 0
                    ? _c("listagem-documentos", {
                        attrs: {
                          documentos: socio.documentos,
                          protocoloCadastroOriginal:
                            _vm.cadastroOriginal.protocolo,
                          ownerDocumento: "SOCIO_REPRESENTANTE",
                          idSocio: socio._id || socio.id,
                          compararDocumentos:
                            _vm.compararInteressado &&
                            _vm.compararInteressado.mudouDocumentosInteressado,
                          versaoCadastro: _vm.versaoCadastro
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      !_vm.isReurb && !_vm.isProcessoFisico && !_vm.isBancoDados
        ? _c(
            "app-divider",
            { attrs: { label: "Endereço" } },
            [
              _c("informacoes-endereco", {
                staticClass: "margin-top",
                attrs: {
                  slot: "body",
                  endereco: _vm.enderecoInteressado,
                  mudouEndereco:
                    _vm.compararInteressado &&
                    _vm.compararInteressado.mudouEndereco
                },
                slot: "body"
              })
            ],
            1
          )
        : _vm._e(),
      _vm.hasConjuge &&
      !_vm.isPessoaJuridicaReurb &&
      _vm.hasConjugeVersionsCadastro
        ? _c(
            "app-divider",
            { attrs: { label: "Cônjuge" } },
            [
              !_vm.isViuvo
                ? _c("informacoes-pessoa", {
                    staticClass: "margin-top",
                    attrs: {
                      slot: "body",
                      pessoa:
                        _vm.interessado.conjuge.pessoa ||
                        _vm.interessado.conjuge ||
                        _vm.interessado.conjuge.pessoaFisica,
                      isConjuge: _vm.hasConjuge,
                      razaoSocialName: _vm.isOnerosoGroup
                        ? "Razão Social:"
                        : "Associação/Comunidade:",
                      compararInformacoesPessoa:
                        _vm.compararInteressado &&
                        _vm.compararInteressado.mudouConjugeInteressado,
                      isProcessoFisico: _vm.isProcessoFisico,
                      isReurb: _vm.isReurb,
                      membroFamilia: _vm.membroConjugePorNome,
                      isBancoDados: _vm.isBancoDados,
                      cnpjRequerente: _vm.cadastroOriginal.cnpjRequerente,
                      razaoSocialRequerente:
                        _vm.cadastroOriginal.razaoSocialRequerente
                    },
                    slot: "body"
                  })
                : _vm.hasDadosConjugeInteressadoViuvo
                ? _c(
                    "div",
                    { attrs: { slot: "body" }, slot: "body" },
                    [
                      _c("app-display", {
                        class:
                          _vm.compararInteressado &&
                          _vm.compararInteressado.mudouPessoa.mudouNome
                            ? "text"
                            : "",
                        attrs: {
                          id: "NOME_VIUVO",
                          label: "Nome:",
                          content: _vm.conjuge.pessoaFisica.nome || "-"
                        }
                      }),
                      _c("app-display", {
                        class: "text",
                        attrs: {
                          id: "DATA_OBITO_CONJUGE",
                          label: "Data de óbito:",
                          content:
                            this.formatDate(
                              _vm.conjuge.pessoaFisica.dataObito
                            ) || "-"
                        }
                      }),
                      _c("app-display", {
                        class:
                          _vm.compararInteressado &&
                          _vm.compararInteressado.mudouPessoa.mudouCPF
                            ? "text"
                            : "",
                        attrs: {
                          id: "CPF_VIUVO",
                          label: "CPF:",
                          content: _vm.conjuge.pessoaFisica.cpf || "-"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : !_vm.isReurb
        ? _c("app-divider", { attrs: { label: "Cônjuge" } }, [
            _c(
              "div",
              {
                staticClass: "margin-top",
                attrs: { slot: "body" },
                slot: "body"
              },
              [
                _c("app-display", {
                  class:
                    _vm.compararInteressado &&
                    _vm.compararInteressado.mudouPossuiConjugeInteressado
                      ? "text"
                      : "",
                  attrs: {
                    id: "POSSUI_CONJUGE",
                    label: "Possui cônjuge?",
                    content: "Não"
                  }
                })
              ],
              1
            )
          ])
        : !_vm.isPessoaJuridicaReurb &&
          !_vm.hasConjugeVersionsCadastro &&
          _vm.isReurb
        ? _c("app-divider", { attrs: { label: "Cônjuge" } }, [
            _c(
              "div",
              {
                staticClass: "margin-top",
                attrs: { slot: "body" },
                slot: "body"
              },
              [
                _c("app-display", {
                  class:
                    _vm.compararInteressado &&
                    _vm.compararInteressado.mudouPossuiConjugeInteressado
                      ? "text"
                      : "",
                  attrs: {
                    id: "POSSUI_CONJUGE",
                    content: "Não foi informado nenhum dado durante o cadastro."
                  }
                })
              ],
              1
            )
          ])
        : _c("app-divider", { attrs: { label: "Cônjuge" } }, [
            _c(
              "div",
              {
                staticClass: "margin-top",
                attrs: { slot: "body" },
                slot: "body"
              },
              [
                _c("app-display", {
                  attrs: {
                    id: "POSSUI_CONJUGE",
                    content: "Não foi informado nenhum dado durante o cadastro."
                  }
                })
              ],
              1
            )
          ]),
      _vm.hasFamilia && !_vm.isPessoaJuridicaReurb
        ? _c("app-divider", {
            class: _vm.compararInteressado.mudouMembroFamilia
              ? "text"
              : "titulo",
            attrs: { label: "Membros da família" }
          })
        : _vm._e(),
      _c(
        "div",
        [
          _vm.membrosNotInteressadoAndConjuge &&
          _vm.membrosNotInteressadoAndConjuge.length > 0 &&
          !_vm.isPessoaJuridicaReurb
            ? _c("app-membro-familia", {
                attrs: {
                  membros: _vm.membrosNotInteressadoAndConjuge,
                  appMembroFamiliaComparar:
                    _vm.compararInteressado &&
                    _vm.compararInteressado.mudouMembroFamilia
                }
              })
            : _vm._e(),
          _vm.membrosNotInteressadoAndConjuge &&
          _vm.membrosNotInteressadoAndConjuge.length === 0 &&
          !_vm.isPessoaJuridicaReurb
            ? _c(
                "div",
                {
                  staticClass: "margin-top",
                  attrs: { slot: "body" },
                  slot: "body"
                },
                [
                  _c("app-display", {
                    attrs: {
                      id: "POSSUI_MEMBRO_FAMILIA",
                      content:
                        "Não foi informado nenhum dado durante o cadastro."
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c818de8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c818de8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/ma/InformacoesInteressado.vue
// module id = null
// module chunks = 